import { memo } from "react";

const SubHeading = ({ subTitle = "" }) => {
  return (
    <>
      <div className="hading-box ">
        <p className="text-box">{subTitle}</p>
      </div>
    </>
  );
};

export default memo(SubHeading);
